import SkillDto from '@/models/Skills/SkillDto';
import BaseAgencyScopeEntityDto from '@/models/Shared/BaseAgencyScopeEntityDto';
import WorkerDto from '@/models/Workers/WorkerDto';
import WorkerSkillStatus from '@/models/WorkerSkills/WorkerSkillStatus';

export default class WorkerSkillDto extends BaseAgencyScopeEntityDto {
    workerId: string;
    worker: WorkerDto = new WorkerDto();
    skillId: string;
    skill: SkillDto = new SkillDto();
    status: WorkerSkillStatus;
}